const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const SignInPage = ({ showSignedOut, onDismissSignedOut }) => {
  const googleLogin = () => {
    const redirectUri = window.location.origin;
    const scope = 'openid email profile';
    const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${encodeURIComponent(GOOGLE_CLIENT_ID)}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=token&scope=${encodeURIComponent(scope)}&prompt=select_account`;
    window.location.href = url;
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {showSignedOut && (
          <div style={styles.signedOutBanner}>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="#22c55e" style={{ flexShrink: 0 }}>
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
            <span>You've been signed out successfully</span>
            <button onClick={onDismissSignedOut} style={styles.dismissBtn}>&times;</button>
          </div>
        )}
        <div style={styles.logoWrap}>
          <span style={styles.logo}>Titler</span>
        </div>
        <h2 style={styles.heading}>Get started free</h2>
        <p style={styles.sub}>Sign in with Google to unlock all features. No credit card required.</p>

        {/* Free credits callout */}
        <div style={styles.creditsBanner}>
          <div style={styles.creditsIcon}>
            <svg viewBox="0 0 24 24" width="22" height="22" fill="#fbbf24">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
            </svg>
          </div>
          <div>
            <span style={styles.creditsTitle}>3 free AI credits included</span>
            <span style={styles.creditsDesc}>Try every feature before you pay anything</span>
          </div>
        </div>

        <button onClick={googleLogin} style={styles.googleBtn} className="titler-signin-btn">
          <svg viewBox="0 0 24 24" width="20" height="20" style={{ flexShrink: 0 }}>
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span>Continue with Google</span>
        </button>

        <p style={styles.trustNote}>Takes 5 seconds. We only need your name and email.</p>

        <div style={styles.divider} />

        <div style={styles.features}>
          <p style={styles.featuresTitle}>What you get instantly:</p>
          <div style={styles.featureList}>
            {[
              { text: 'YouTube URL transcript analysis', icon: '#a78bfa' },
              { text: 'AI-generated title suggestions', icon: '#a78bfa' },
              { text: 'CTR Simulator — test titles before publishing', icon: '#a78bfa' },
              { text: 'Sentiment & tone analysis', icon: '#a78bfa' },
              { text: 'SEO tags & description generator', icon: '#a78bfa' },
              { text: 'Analysis history & saved results', icon: '#a78bfa' },
            ].map(f => (
              <div key={f.text} style={styles.featureItem}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill={f.icon} style={{ flexShrink: 0, marginTop: '2px' }}>
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                <span>{f.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={styles.noCardRow}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="#22c55e" style={{ flexShrink: 0 }}>
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
          </svg>
          <span style={styles.noCardText}>No credit card required. No spam. Cancel anytime.</span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(160deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '40px 20px',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  card: {
    width: '100%', maxWidth: '440px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '16px', padding: '40px 32px',
  },
  logoWrap: {
    textAlign: 'center', marginBottom: '24px',
  },
  logo: {
    fontSize: '36px', fontWeight: '800', letterSpacing: '-1.5px',
    background: 'linear-gradient(135deg, #a78bfa, #818cf8, #6366f1)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
  },
  heading: {
    margin: '0 0 8px', fontSize: '24px', fontWeight: '700',
    color: '#e2e8f0', textAlign: 'center',
  },
  sub: {
    margin: '0 0 24px', fontSize: '14px', color: '#94a3b8',
    textAlign: 'center', lineHeight: '1.5',
  },
  creditsBanner: {
    display: 'flex', alignItems: 'center', gap: '14px',
    padding: '14px 18px', borderRadius: '12px', marginBottom: '24px',
    background: 'rgba(251, 191, 36, 0.08)',
    border: '1px solid rgba(251, 191, 36, 0.2)',
  },
  creditsIcon: {
    width: '42px', height: '42px', borderRadius: '10px',
    background: 'rgba(251, 191, 36, 0.12)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0,
  },
  creditsTitle: {
    display: 'block', fontSize: '15px', fontWeight: '700', color: '#fbbf24',
    marginBottom: '2px',
  },
  creditsDesc: {
    display: 'block', fontSize: '12px', color: '#94a3b8',
  },
  googleBtn: {
    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: '12px', padding: '14px 20px', borderRadius: '12px',
    border: 'none',
    background: 'linear-gradient(135deg, #7c3aed, #6366f1)',
    color: '#fff', fontSize: '16px', fontWeight: '700',
    cursor: 'pointer', fontFamily: 'inherit',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 4px 16px rgba(124,58,237,0.25)',
  },
  trustNote: {
    margin: '12px 0 0', fontSize: '12px', color: '#64748b', textAlign: 'center',
  },
  divider: {
    height: '1px', background: 'rgba(255,255,255,0.06)', margin: '24px 0',
  },
  features: {
    marginBottom: '20px',
  },
  featuresTitle: {
    margin: '0 0 14px', fontSize: '13px', fontWeight: '600',
    color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.3px',
  },
  featureList: {
    display: 'flex', flexDirection: 'column', gap: '10px',
  },
  featureItem: {
    display: 'flex', alignItems: 'flex-start', gap: '10px',
    fontSize: '14px', color: '#cbd5e1', lineHeight: '1.4',
  },
  noCardRow: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
    padding: '12px', borderRadius: '10px',
    background: 'rgba(34, 197, 94, 0.06)',
    border: '1px solid rgba(34, 197, 94, 0.15)',
  },
  noCardText: {
    fontSize: '12px', color: '#4ade80', fontWeight: '500',
  },
  signedOutBanner: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '12px 16px', borderRadius: '10px', marginBottom: '20px',
    background: 'rgba(34, 197, 94, 0.1)',
    border: '1px solid rgba(34, 197, 94, 0.3)',
    color: '#4ade80', fontSize: '14px', fontWeight: '500',
  },
  dismissBtn: {
    marginLeft: 'auto', background: 'none', border: 'none',
    color: '#4ade80', fontSize: '18px', cursor: 'pointer',
    padding: '0 4px', lineHeight: 1,
  },
};

export default SignInPage;
